import { call, put } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import notify from 'devextreme/ui/notify';
import * as action from '../actions/adminMailing';
import { post } from '../../utils/api';
import { modalErrorOpen } from '../actions/modalError';

export function* getMailing({ payload }) {
  try {
    const response = yield call(post, '/admin/mailing_lists/find', payload);
    yield put(action.getMailingSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getMailingFail());
  }
}

export function* addMailing({ payload }) {
  try {
    yield call(post, `/admin/mailing_lists/${payload.data.id}`, { recipients: payload.data.recipients });
    yield put(action.addMailingSuccess());
    yield call(
      notify,
      {
        message: formatMessage('dataSuccess'),
        height: 64,
        width: 354,
        position: {
          at: 'top center',
          my: 'top center',
          offset: '0 48'
        }
      },
      'success',
      2000
    );
    const response = yield call(post, '/admin/mailing_lists/find', payload.filter);
    yield put(action.getMailingSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.addMailingFail());
  }
}
